import {
  attachAsyncAppsFromManifest,
  getStagingVersionedUrl,
} from "@gohighlevel/ghl-module-federation-plugin";

import jenkinsConfig from "../../jenkins-config";

interface Config {
  voiceAiApp: string;
  leadgenPaymentsApp: string;
  paymentsApp: string;
  reputationApp: string;
  certificatesApp: string;
  yextApp: string;
  templateLibraryApp: string;
  adPublishingApp: string;
  reportingApp: string;
  notificationApp: string;
  wordpressApp: string;
  resellingApp: string;
  affiliateDashboardApp: string;
  agencyDashboardApp: string;
  saasApp: string;
  locationBillingApp: string;
  companyApp: string;
  locationsApp: string;
  phoneIntegrationApp: string;
  contentAIApp: string;
  platformBillingApp: string;
  agencyInternalToolsApp: string;
  preferenceManagementApp: string;
  giftCardsApp: string;
  conversationsUtilitiesApp: string;
  i18nFeedbackApp: string;
  contactsHighriseApp: string;
  conversationsApp: string;
  crmObjectsSettingsApp: string;
  ghlContactRestoreApp: string;
  contactsApp: string;
  brandBoardsApp: string;
  externalTrackingApp: string;
  seoApp: string;
  countdownTimerApp: string;
  qrCodeListApp: string;
  qrCodeBuilderApp: string;
  socialPlannerApp: string;
  customObjectsApp: string;
  conversationsV2App: string;
  authApp: string;
  mediaCenterApp: string;
  quizResultBuilderApp: string;
  funnelWebsiteAnalytics: string
  funnelWebsiteApp: string;
  redirectApp: string
  domainConnectApp: string
  chatWidgetApp: string;
  domainResellingApp: string;
}

interface remoteConfigEnv {
  staging: Config;
  interop: Config;
  beta: Config;
  production: Config;
}

const remoteConfigEnv: remoteConfigEnv = {
  staging: {
    i18nFeedbackApp:
      "https://staging.appcdn.leadconnectorhq.com/leadgen/i18n-feedback/remoteEntry.js?nocache=true",
    reputationApp:
      "https://staging.appcdn.leadconnectorhq.com/revex/reputation/remoteEntry.js?nocache=true",
    yextApp:
      "https://staging.appcdn.leadconnectorhq.com/revex/yext/remoteEntry.js?nocache=true",
    agencyDashboardApp:
      "https://staging.appcdn.leadconnectorhq.com/revex/agency-dashboard/remoteEntry.js?nocache=true",
    voiceAiApp:
      "https://staging.appcdn.leadconnectorhq.com/crm/voice-ai/remoteEntry.js?nocache=true",
    certificatesApp:
      "https://staging.appcdn.leadconnectorhq.com/revex/certificates-builder/remoteEntry.js?nocache=true",
    templateLibraryApp:
      "https://staging.appcdn.leadconnectorhq.com/leadgen/template-library/remoteEntry.js?nocache=true",
    adPublishingApp:
      "https://staging.appcdn.leadconnectorhq.com/leadgen-ad-publishing/ad-publishing/remoteEntry.js?nocache=true",
    reportingApp:
      "https://staging.appcdn.leadconnectorhq.com/automation-reporting/reporting/remoteEntry.js?nocache=true",
    notificationApp:
      "https://staging.appcdn.leadconnectorhq.com/automation-reporting/notification/remoteEntry.js?nocache=true",
    wordpressApp:
      "https://staging.appcdn.leadconnectorhq.com/revex/wordpress/remoteEntry.js?nocache=true",
    resellingApp:
      "https://staging.appcdn.leadconnectorhq.com/revex/reselling/remoteEntry.js?nocache=true",
    affiliateDashboardApp:
      "https://staging.appcdn.leadconnectorhq.com/revex/affiliate-portal/remoteEntry.js?nocache=true",
    saasApp:
      "https://staging.appcdn.leadconnectorhq.com/revex/saas/remoteEntry.js?nocache=true",
    leadgenPaymentsApp:
      "https://staging.appcdn.leadconnectorhq.com/leadgen/payments-widgets/remoteEntry.js?nocache=true",
    paymentsApp:
      "https://staging.appcdn.leadconnectorhq.com/leadgen/ghl-payments/remoteEntry.js?nocache=true",
    locationBillingApp:
      "https://staging.appcdn.leadconnectorhq.com/revex/location-billing/remoteEntry.js?nocache=true",
    companyApp:
      "https://staging.appcdn.leadconnectorhq.com/revex/company/remoteEntry.js?nocache=true",
    locationsApp:
      "https://staging.appcdn.leadconnectorhq.com/revex/locations/remoteEntry.js?nocache=true",
    phoneIntegrationApp:
      "https://staging.appcdn.leadconnectorhq.com/revex/phone-integration/remoteEntry.js?nocache=true",
    contentAIApp:
      "https://staging.appcdn.leadconnectorhq.com/crm/content-ai/remoteEntry.js?nocache=true",
    platformBillingApp:
      "https://staging.appcdn.leadconnectorhq.com/revex/platform-billing/remoteEntry.js?nocache=true",
    agencyInternalToolsApp:
      "https://staging.appcdn.leadconnectorhq.com/revex/agency-internaltools/remoteEntry.js?nocache=true",
    preferenceManagementApp:
      "https://staging.appcdn.leadconnectorhq.com/crm/preference-management/remoteEntry.js?nocache=true",
    giftCardsApp:
      "https://staging.appcdn.leadconnectorhq.com/leadgen/gift-cards/remoteEntry.js?nocache=true",
    conversationsUtilitiesApp:
      "https://staging.appcdn.leadconnectorhq.com/crm/conversations-utilities/remoteEntry.js?nocache=true",
    contactsHighriseApp:
      "https://staging.appcdn.leadconnectorhq.com/crm/contacts-highrise/remoteEntry.js?nocache=true",
    conversationsApp:
      "https://staging.appcdn.leadconnectorhq.com/crm/conversations-components/remoteEntry.js?nocache=true",
    crmObjectsSettingsApp:
      'https://staging.appcdn.leadconnectorhq.com/crm/crm-objects-settings/remoteEntry.js?nocache=true',
    ghlContactRestoreApp: 'https://staging.appcdn.leadconnectorhq.com/crm/contacts-restore/remoteEntry.js?nocache=true',
    contactsApp: 'https://staging.appcdn.leadconnectorhq.com/crm/contacts/remoteEntry.js?nocache=true',
    funnelWebsiteApp: 'https://staging.appcdn.leadconnectorhq.com/leadgen/funnel-website/remoteEntry.js?nocache=true',
    brandBoardsApp: 'https://staging.appcdn.leadconnectorhq.com/leadgen/brand-boards/remoteEntry.js?nocache=true',
    externalTrackingApp:
      "https://staging.appcdn.leadconnectorhq.com/leadgen/external-tracking/remoteEntry.js?nocache=true",
    seoApp:
      "https://staging.appcdn.leadconnectorhq.com/leadgen/seoApp/remoteEntry.js?nocache=true",
    countdownTimerApp:
      "https://staging.appcdn.leadconnectorhq.com/leadgen/countdown-timer/remoteEntry.js?nocache=true",
    qrCodeListApp:
      "https://staging.appcdn.leadconnectorhq.com/leadgen/qr-code-list/remoteEntry.js?nocache=true",
    qrCodeBuilderApp:
      "https://staging.appcdn.leadconnectorhq.com/leadgen/qr-code-builder/remoteEntry.js?nocache=true",
    socialPlannerApp:
      "https://staging.appcdn.leadconnectorhq.com/leadgen/SocialPlanner/remoteEntry.js?nocache=true",
    customObjectsApp:
      "https://staging.appcdn.leadconnectorhq.com/crm/custom-objects/remoteEntry.js?nocache=true",
    conversationsV2App:
      "https://staging.appcdn.leadconnectorhq.com/crm/conversations-new-ui/remoteEntry.js?nocache=true",
    authApp:
      "https://staging.appcdn.leadconnectorhq.com/crm/auth/remoteEntry.js?nocache=true",
    mediaCenterApp:
      "https://staging.appcdn.leadconnectorhq.com/leadgen/media-center/remoteEntry.js?nocache=true",
    quizResultBuilderApp:
      "https://staging.appcdn.leadconnectorhq.com/leadgen/quiz-result-builder/remoteEntry.js?nocache=true",
    funnelWebsiteAnalytics:
      'https://staging.appcdn.leadconnectorhq.com/leadgen/funnel-website-analytics/remoteEntry.js?nocache=true',
    redirectApp:
      'https://staging.appcdn.leadconnectorhq.com/leadgen/funnel-website-redirect/remoteEntry.js?nocache=true',
    domainConnectApp:
      'https://staging.appcdn.leadconnectorhq.com/leadgen/funnel-website-domain-connect/remoteEntry.js?nocache=true',
    chatWidgetApp: 'https://staging.appcdn.leadconnectorhq.com/leadgen/chat-widget/remoteEntry.js?nocache=true',
    domainResellingApp:
    'https://staging.appcdn.leadconnectorhq.com/leadgen/domain-reselling/remoteEntry.js?nocache=true',
  },
  interop: {
    i18nFeedbackApp:
      "https://interop.appcdn.leadconnectorhq.com/leadgen/i18n-feedback/remoteEntry.js?nocache=true",
    reputationApp:
      "https://interop.appcdn.leadconnectorhq.com/revex/reputation/remoteEntry.js?nocache=true",
    yextApp:
      "https://interop.appcdn.leadconnectorhq.com/revex/yext/remoteEntry.js?nocache=true",
    agencyDashboardApp:
      "https://interop.appcdn.leadconnectorhq.com/revex/agency-dashboard/remoteEntry.js?nocache=true",
    voiceAiApp:
      "https://interop.appcdn.leadconnectorhq.com/crm/voice-ai/remoteEntry.js?nocache=true",
    certificatesApp:
      "https://interop.appcdn.leadconnectorhq.com/revex/certificates-builder/remoteEntry.js?nocache=true",
    templateLibraryApp:
      "https://interop.appcdn.leadconnectorhq.com/leadgen/template-library/remoteEntry.js?nocache=true",
    adPublishingApp:
      "https://interop.appcdn.leadconnectorhq.com/leadgen-ad-publishing/ad-publishing/remoteEntry.js?nocache=true",
    reportingApp:
      "https://interop.appcdn.leadconnectorhq.com/automation-reporting/reporting/remoteEntry.js?nocache=true",
    notificationApp:
      "https://interop.appcdn.leadconnectorhq.com/automation-reporting/notification/remoteEntry.js?nocache=true",
    wordpressApp:
      "https://interop.appcdn.leadconnectorhq.com/revex/wordpress/remoteEntry.js?nocache=true",
    resellingApp:
      "https://interop.appcdn.leadconnectorhq.com/revex/reselling/remoteEntry.js?nocache=true",
    affiliateDashboardApp:
      "https://interop.appcdn.leadconnectorhq.com/revex/affiliate-portal/remoteEntry.js?nocache=true",
    saasApp:
      "https://interop.appcdn.leadconnectorhq.com/revex/saas/remoteEntry.js?nocache=true",
    leadgenPaymentsApp:
      "https://interop.appcdn.leadconnectorhq.com/leadgen/payments-widgets/remoteEntry.js?nocache=true",
    paymentsApp:
      "https://interop.appcdn.leadconnectorhq.com/leadgen/ghl-payments/remoteEntry.js?nocache=true",
    locationBillingApp:
      "https://interop.appcdn.leadconnectorhq.com/revex/location-billing/remoteEntry.js?nocache=true",
    companyApp:
      "https://interop.appcdn.leadconnectorhq.com/revex/company/remoteEntry.js?nocache=true",
    locationsApp:
      "https://interop.appcdn.leadconnectorhq.com/revex/locations/remoteEntry.js?nocache=true",
    contentAIApp:
      "https://interop.appcdn.leadconnectorhq.com/crm/content-ai/remoteEntry.js?nocache=true",
    platformBillingApp:
      "https://interop.appcdn.leadconnectorhq.com/revex/platform-billing/remoteEntry.js?nocache=true",
    agencyInternalToolsApp:
      "https://interop.appcdn.leadconnectorhq.com/revex/agency-internaltools/remoteEntry.js?nocache=true",
    preferenceManagementApp:
      "https://interop.appcdn.leadconnectorhq.com/crm/preference-management/remoteEntry.js?nocache=true",
    giftCardsApp:
      "https://interop.appcdn.leadconnectorhq.com/leadgen/gift-cards/remoteEntry.js?nocache=true",
    conversationsUtilitiesApp:
      "https://interop.appcdn.leadconnectorhq.com/crm/conversations-utilities/remoteEntry.js?nocache=true",
    phoneIntegrationApp:
      "https://interop.appcdn.leadconnectorhq.com/revex/phone-integration/remoteEntry.js?nocache=true",
    contactsHighriseApp:
      "https://interop.appcdn.leadconnectorhq.com/crm/contacts-highrise/remoteEntry.js?nocache=true",
    conversationsApp:
      "https://interop.appcdn.leadconnectorhq.com/crm/conversations-components/remoteEntry.js?nocache=true",
    crmObjectsSettingsApp:
      'https://interop.appcdn.leadconnectorhq.com/crm/crm-objects-settings/remoteEntry.js?nocache=true',
    ghlContactRestoreApp: 'https://interop.appcdn.leadconnectorhq.com/crm/contacts-restore/remoteEntry.js?nocache=true',
    contactsApp: 'https://interop.appcdn.leadconnectorhq.com/crm/contacts/remoteEntry.js?nocache=true',
    funnelWebsiteApp: 'https://interop.appcdn.leadconnectorhq.com/leadgen/funnel-website/remoteEntry.js?nocache=true',
    brandBoardsApp: 'https://interop.appcdn.leadconnectorhq.com/leadgen/brand-boards/remoteEntry.js?nocache=true',
    externalTrackingApp:
      "https://interop.appcdn.leadconnectorhq.com/leadgen/external-tracking/remoteEntry.js?nocache=true",
    seoApp:
      "https://interop.appcdn.leadconnectorhq.com/leadgen/seoApp/remoteEntry.js?nocache=true",
    countdownTimerApp:
      "https://interop.appcdn.leadconnectorhq.com/leadgen/countdown-timer/remoteEntry.js?nocache=true",
    qrCodeListApp:
      "https://interop.appcdn.leadconnectorhq.com/leadgen/qr-code-list/remoteEntry.js?nocache=true",
    qrCodeBuilderApp:
      "https://interop.appcdn.leadconnectorhq.com/leadgen/qr-code-builder/remoteEntry.js?nocache=true",
    socialPlannerApp:
      "https://interop.appcdn.leadconnectorhq.com/leadgen/SocialPlanner/remoteEntry.js?nocache=true",
    customObjectsApp:
      "https://interop.appcdn.leadconnectorhq.com/crm/custom-objects/remoteEntry.js?nocache=true",
    conversationsV2App:
      "https://interop.appcdn.leadconnectorhq.com/crm/conversations-new-ui/remoteEntry.js?nocache=true",
    authApp:
      "https://interop.appcdn.leadconnectorhq.com/crm/auth/remoteEntry.js?nocache=true",
    mediaCenterApp:
      "https://interop.appcdn.leadconnectorhq.com/leadgen/media-center/remoteEntry.js?nocache=true",
    quizResultBuilderApp:
      "https://interop.appcdn.leadconnectorhq.com/leadgen/quiz-result-builder/remoteEntry.js?nocache=true",
    funnelWebsiteAnalytics:
      'https://interop.appcdn.leadconnectorhq.com/leadgen/funnel-website-analytics/remoteEntry.js?nocache=true',
    redirectApp:
      'https://interop.appcdn.leadconnectorhq.com/leadgen/funnel-website-redirect/remoteEntry.js?nocache=true',
    domainConnectApp:
      'https://interop.appcdn.leadconnectorhq.com/leadgen/funnel-website-domain-connect/remoteEntry.js?nocache=true',
    chatWidgetApp: 'https://interop.appcdn.leadconnectorhq.com/leadgen/chat-widget/remoteEntry.js?nocache=true',
    domainResellingApp:
    'https://interop.appcdn.leadconnectorhq.com/leadgen/domain-reselling/remoteEntry.js?nocache=true',
  },
  beta: {
    i18nFeedbackApp:
      "https://beta.appcdn.leadconnectorhq.com/leadgen/i18n-feedback/remoteEntry.js?nocache=true",
    reputationApp:
      "https://beta.appcdn.leadconnectorhq.com/revex/reputation/remoteEntry.js?nocache=true",
    yextApp:
      "https://beta.appcdn.leadconnectorhq.com/revex/yext/remoteEntry.js?nocache=true",
    agencyDashboardApp:
      "https://beta.appcdn.leadconnectorhq.com/revex/agency-dashboard/remoteEntry.js?nocache=true",
    voiceAiApp:
      "https://beta.appcdn.leadconnectorhq.com/crm/voice-ai/remoteEntry.js?nocache=true",
    certificatesApp:
      "https://beta.appcdn.leadconnectorhq.com/revex/certificates-builder/remoteEntry.js?nocache=true",
    templateLibraryApp:
      "https://beta.appcdn.leadconnectorhq.com/leadgen/template-library/remoteEntry.js?nocache=true",
    adPublishingApp:
      "https://beta.appcdn.leadconnectorhq.com/leadgen-ad-publishing/ad-publishing/remoteEntry.js?nocache=true",
    reportingApp:
      "https://beta.appcdn.leadconnectorhq.com/automation-reporting/reporting/remoteEntry.js?nocache=true",
    notificationApp:
      "https://beta.appcdn.leadconnectorhq.com/automation-reporting/notification/remoteEntry.js?nocache=true",
    wordpressApp:
      "https://beta.appcdn.leadconnectorhq.com/revex/wordpress/remoteEntry.js?nocache=true",
    resellingApp:
      "https://beta.appcdn.leadconnectorhq.com/revex/reselling/remoteEntry.js?nocache=true",
    affiliateDashboardApp:
      "https://beta.appcdn.leadconnectorhq.com/revex/affiliate-portal/remoteEntry.js?nocache=true",
    saasApp:
      "https://beta.appcdn.leadconnectorhq.com/revex/saas/remoteEntry.js?nocache=true",
    leadgenPaymentsApp:
      "https://beta.appcdn.leadconnectorhq.com/leadgen/payments-widgets/remoteEntry.js?nocache=true",
    paymentsApp:
      "https://beta.appcdn.leadconnectorhq.com/leadgen/ghl-payments/remoteEntry.js?nocache=true",
    locationBillingApp:
      "https://beta.appcdn.leadconnectorhq.com/revex/location-billing/remoteEntry.js?nocache=true",
    companyApp:
      "https://beta.appcdn.leadconnectorhq.com/revex/company/remoteEntry.js?nocache=true",
    locationsApp:
      "https://beta.appcdn.leadconnectorhq.com/revex/locations/remoteEntry.js?nocache=true",
    preferenceManagementApp:
      "https://beta.appcdn.leadconnectorhq.com/crm/preference-management/remoteEntry.js?nocache=true",
    contentAIApp:
      "https://beta.appcdn.leadconnectorhq.com/crm/content-ai/remoteEntry.js?nocache=true",
    platformBillingApp:
      "https://beta.appcdn.leadconnectorhq.com/revex/platform-billing/remoteEntry.js?nocache=true",
    agencyInternalToolsApp:
      "https://beta.appcdn.leadconnectorhq.com/revex/agency-internaltools/remoteEntry.js?nocache=true",
    phoneIntegrationApp:
      "https://beta.appcdn.leadconnectorhq.com/revex/phone-integration/remoteEntry.js?nocache=true",
    giftCardsApp:
      "https://beta.appcdn.leadconnectorhq.com/leadgen/gift-cards/remoteEntry.js?nocache=true",
    conversationsUtilitiesApp:
      "https://beta.appcdn.leadconnectorhq.com/crm/conversations-utilities/remoteEntry.js?nocache=true",
    contactsHighriseApp:
      "https://beta.appcdn.leadconnectorhq.com/crm/contacts-highrise/remoteEntry.js?nocache=true",
    conversationsApp:
      "https://beta.appcdn.leadconnectorhq.com/crm/conversations-components/remoteEntry.js?nocache=true",
    crmObjectsSettingsApp:
      "https://beta.appcdn.leadconnectorhq.com/crm/crm-objects-settings/remoteEntry.js?nocache=true",
    ghlContactRestoreApp:
      "https://beta.appcdn.leadconnectorhq.com/crm/contacts-restore/remoteEntry.js?nocache=true",
    contactsApp:
      "https://beta.appcdn.leadconnectorhq.com/crm/contacts/remoteEntry.js?nocache=true",
    funnelWebsiteApp: 'https://beta.appcdn.leadconnectorhq.com/leadgen/funnel-website/remoteEntry.js?nocache=true',
    brandBoardsApp:
      "https://beta.appcdn.leadconnectorhq.com/leadgen/brand-boards/remoteEntry.js?nocache=true",
    externalTrackingApp:
      "https://beta.appcdn.leadconnectorhq.com/leadgen/external-tracking/remoteEntry.js?nocache=true",
    seoApp:
      "https://beta.appcdn.leadconnectorhq.com/leadgen/seoApp/remoteEntry.js?nocache=true",
    countdownTimerApp:
      "https://beta.appcdn.leadconnectorhq.com/leadgen/countdown-timer/remoteEntry.js?nocache=true",
    qrCodeListApp:
      "https://beta.appcdn.leadconnectorhq.com/leadgen/qr-code-list/remoteEntry.js?nocache=true",
    qrCodeBuilderApp:
      "https://beta.appcdn.leadconnectorhq.com/leadgen/qr-code-builder/remoteEntry.js?nocache=true",
    socialPlannerApp:
      "https://beta.appcdn.leadconnectorhq.com/leadgen/SocialPlanner/remoteEntry.js?nocache=true",
    customObjectsApp:
      "https://beta.appcdn.leadconnectorhq.com/crm/custom-objects/remoteEntry.js?nocache=true",
    conversationsV2App:
      "https://beta.appcdn.leadconnectorhq.com/crm/conversations-new-ui/remoteEntry.js?nocache=true",
    authApp:
      "https://beta.appcdn.leadconnectorhq.com/crm/auth/remoteEntry.js?nocache=true",
    mediaCenterApp:
      "https://beta.appcdn.leadconnectorhq.com/leadgen/media-center/remoteEntry.js?nocache=true",
    quizResultBuilderApp:
      "https://beta.appcdn.leadconnectorhq.com/leadgen/quiz-result-builder/remoteEntry.js?nocache=true",
    funnelWebsiteAnalytics:
      'https://beta.appcdn.leadconnectorhq.com/leadgen/funnel-website-analytics/remoteEntry.js?nocache=true',
    redirectApp: 'https://beta.appcdn.leadconnectorhq.com/leadgen/funnel-website-redirect/remoteEntry.js?nocache=true',
    domainConnectApp:
      'https://beta.appcdn.leadconnectorhq.com/leadgen/funnel-website-domain-connect/remoteEntry.js?nocache=true',
    chatWidgetApp: 'https://beta.appcdn.leadconnectorhq.com/leadgen/chat-widget/remoteEntry.js?nocache=true',
    domainResellingApp: 'https://beta.appcdn.leadconnectorhq.com/leadgen/domain-reselling/remoteEntry.js?nocache=true',
  },
  production: {
    i18nFeedbackApp:
      "https://appcdn.leadconnectorhq.com/leadgen/i18n-feedback/remoteEntry.js?nocache=true",
    reputationApp:
      "https://appcdn.leadconnectorhq.com/revex/reputation/remoteEntry.js?nocache=true",
    yextApp:
      "https://appcdn.leadconnectorhq.com/revex/yext/remoteEntry.js?nocache=true",
    agencyDashboardApp:
      "https://appcdn.leadconnectorhq.com/revex/agency-dashboard/remoteEntry.js?nocache=true",
    voiceAiApp:
      "https://appcdn.leadconnectorhq.com/crm/voice-ai/remoteEntry.js?nocache=true",
    certificatesApp:
      "https://appcdn.leadconnectorhq.com/revex/certificates-builder/remoteEntry.js?nocache=true",
    templateLibraryApp:
      "https://appcdn.leadconnectorhq.com/leadgen/template-library/remoteEntry.js?nocache=true",
    adPublishingApp:
      "https://appcdn.leadconnectorhq.com/leadgen-ad-publishing/ad-publishing/remoteEntry.js?nocache=true",
    reportingApp:
      "https://appcdn.leadconnectorhq.com/automation-reporting/reporting/remoteEntry.js?nocache=true",
    notificationApp:
      "https://appcdn.leadconnectorhq.com/automation-reporting/notification/remoteEntry.js?nocache=true",
    wordpressApp:
      "https://appcdn.leadconnectorhq.com/revex/wordpress/remoteEntry.js?nocache=true",
    resellingApp:
      "https://appcdn.leadconnectorhq.com/revex/reselling/remoteEntry.js?nocache=true",
    affiliateDashboardApp:
      "https://appcdn.leadconnectorhq.com/revex/affiliate-portal/remoteEntry.js?nocache=true",
    saasApp:
      "https://appcdn.leadconnectorhq.com/revex/saas/remoteEntry.js?nocache=true",
    leadgenPaymentsApp:
      "https://appcdn.leadconnectorhq.com/leadgen/payments-widgets/remoteEntry.js?nocache=true",
    paymentsApp:
      "https://appcdn.leadconnectorhq.com/leadgen/ghl-payments/remoteEntry.js?nocache=true",
    locationBillingApp:
      "https://appcdn.leadconnectorhq.com/revex/location-billing/remoteEntry.js?nocache=true",
    companyApp:
      "https://appcdn.leadconnectorhq.com/revex/company/remoteEntry.js?nocache=true",
    locationsApp:
      "https://appcdn.leadconnectorhq.com/revex/locations/remoteEntry.js?nocache=true",
    phoneIntegrationApp:
      "https://appcdn.leadconnectorhq.com/revex/phone-integration/remoteEntry.js?nocache=true",
    contentAIApp:
      "https://appcdn.leadconnectorhq.com/crm/content-ai/remoteEntry.js?nocache=true",
    platformBillingApp:
      "https://appcdn.leadconnectorhq.com/revex/platform-billing/remoteEntry.js?nocache=true",
    agencyInternalToolsApp:
      "https://appcdn.leadconnectorhq.com/revex/agency-internaltools/remoteEntry.js?nocache=true",
    preferenceManagementApp:
      "https://appcdn.leadconnectorhq.com/crm/preference-management/remoteEntry.js?nocache=true",
    giftCardsApp:
      "https://appcdn.leadconnectorhq.com/leadgen/gift-cards/remoteEntry.js?nocache=true",
    conversationsUtilitiesApp:
      "https://appcdn.leadconnectorhq.com/crm/conversations-utilities/remoteEntry.js?nocache=true",
    contactsHighriseApp:
      "https://appcdn.leadconnectorhq.com/crm/contacts-highrise/remoteEntry.js?nocache=true",
    conversationsApp:
      "https://appcdn.leadconnectorhq.com/crm/conversations-components/remoteEntry.js?nocache=true",
    crmObjectsSettingsApp:
      "https://appcdn.leadconnectorhq.com/crm/crm-objects-settings/remoteEntry.js?nocache=true",
    ghlContactRestoreApp:
      "https://appcdn.leadconnectorhq.com/crm/contacts-restore/remoteEntry.js?nocache=true",
    funnelWebsiteApp: 'https://appcdn.leadconnectorhq.com/leadgen/funnel-website/remoteEntry.js?nocache=true',
    contactsApp:
      "https://appcdn.leadconnectorhq.com/crm/contacts/remoteEntry.js?nocache=true",
    brandBoardsApp:
      "https://appcdn.leadconnectorhq.com/leadgen/brand-boards/remoteEntry.js?nocache=true",
    externalTrackingApp:
      "https://appcdn.leadconnectorhq.com/leadgen/external-tracking/remoteEntry.js?nocache=true",
    seoApp:
      "https://appcdn.leadconnectorhq.com/leadgen/seoApp/remoteEntry.js?nocache=true",
    countdownTimerApp:
      "https://appcdn.leadconnectorhq.com/leadgen/countdown-timer/remoteEntry.js?nocache=true",
    qrCodeListApp:
      "https://appcdn.leadconnectorhq.com/leadgen/qr-code-list/remoteEntry.js?nocache=true",
    qrCodeBuilderApp:
      "https://appcdn.leadconnectorhq.com/leadgen/qr-code-builder/remoteEntry.js?nocache=true",
    socialPlannerApp:
      "https://appcdn.leadconnectorhq.com/leadgen/SocialPlanner/remoteEntry.js?nocache=true",
    customObjectsApp:
      "https://appcdn.leadconnectorhq.com/crm/custom-objects/remoteEntry.js?nocache=true",
    conversationsV2App:
      "https://appcdn.leadconnectorhq.com/crm/conversations-new-ui/remoteEntry.js?nocache=true",
    authApp:
      "https://appcdn.leadconnectorhq.com/crm/auth/remoteEntry.js?nocache=true",
    mediaCenterApp:
      "https://appcdn.leadconnectorhq.com/leadgen/media-center/remoteEntry.js?nocache=true",
    quizResultBuilderApp:
      "https://appcdn.leadconnectorhq.com/leadgen/quiz-result-builder/remoteEntry.js?nocache=true",
    funnelWebsiteAnalytics:
      'https://appcdn.leadconnectorhq.com/leadgen/funnel-website-analytics/remoteEntry.js?nocache=true',
    redirectApp: 'https://appcdn.leadconnectorhq.com/leadgen/funnel-website-redirect/remoteEntry.js?nocache=true',
    domainConnectApp:
      'https://appcdn.leadconnectorhq.com/leadgen/funnel-website-domain-connect/remoteEntry.js?nocache=true',
    chatWidgetApp: 'https://appcdn.leadconnectorhq.com/leadgen/chat-widget/remoteEntry.js?nocache=true',
    domainResellingApp: 'https://appcdn.leadconnectorhq.com/leadgen/domain-reselling/remoteEntry.js?nocache=true',
  },
};

let config =
  remoteConfigEnv[
    process.env.NODE_ENV === "development"
      ? "staging"
      : (process.env.NODE_ENV as keyof remoteConfigEnv)
  ];

if (process.env.NODE_ENV === "development") {
  // config.i18nFeedbackApp = 'http://localhost:3001/remoteEntry.js?nocache=true'
  // config.voiceAiApp = 'http://localhost:3002/remoteEntry.js?nocache=true'
  // config.reputationApp = 'http://localhost:4002/remoteEntry.js?nocache=true'
  // config.yextApp = 'http://localhost:4003/remoteEntry.js?nocache=true'
  // config.certificatesApp = 'http://localhost:3004/remoteEntry.js?nocache=true'
  // config.templateLibraryApp = 'http://localhost:8083/remoteEntry.js?nocache=true'
  // config.adPublishingApp = 'http://localhost:3005/remoteEntry.js?nocache=true'
  // config.notificationApp = 'http://localhost:3060/remoteEntry.js?nocache=true'
  // config.wordpressApp = 'http://localhost:4003/remoteEntry.js?nocache=true&app=wordpress'
  // config.affiliateDashboardApp = 'http://localhost:5002/remoteEntry.js?nocache=true'
  // config.leadgenPaymentsApp = 'http://localhost:3002/remoteEntry.js'
  // config.paymentsApp = 'http://localhost:3040/remoteEntry.js'
  // config.agencyDashboardApp = 'http://localhost:3051/remoteEntry.js'
  // config.saasApp = 'http://localhost:3051/remoteEntry.js'
  // config.locationBillingApp = 'http://localhost:4320/remoteEntry.js?nocache=true'
  // config.companyApp = 'http://localhost:5003/remoteEntry.js?nocache=true'
  // config.locationsApp = 'http://localhost:4320/remoteEntry.js?nocache=true'
  // config.contentAIApp = 'http://localhost:3003/remoteEntry.js?nocache=true'
  // config.platformBillingApp = 'http://localhost:4320/remoteEntry.js?nocache=true'
  // config.preferenceManagementApp = 'http://localhost:3035/remoteEntry.js?nocache=true'
  //config.platformBillingApp = 'http://localhost:4320/remoteEntry.js?nocache=true'
  // config.agencyInternalToolsApp = 'http://localhost:4322/remoteEntry.js?nocache=true'
  // config.giftCardsApp = 'http://localhost:3050/remoteEntry.js?nocache=true'
  // config.conversationsUtilitiesApp = 'http://localhost:3001/remoteEntry.js?nocache=true'
  // config.conversationsApp = 'http://localhost:3002/remoteEntry.js?nocache=true'
  // config.contactsApp = 'http://localhost:3006/remoteEntry.js'
  // config.phoneIntegrationApp = 'http://localhost:4001/remoteEntry.js?nocache=true'
  // config.externalTrackingApp = 'http://localhost:3030/remoteEntry.js?nocache=true';
  // config.seoApp = 'http://localhost:3015/remoteEntry.js?nocache=true'
  // config.socialPlannerApp = 'http://localhost:10003/remoteEntry.js?nocache=true'
  // config.conversationsV2App = 'http://localhost:3002/remoteEntry.js?nocache=true'
}

if (
  process.env.NODE_ENV === "staging" ||
  process.env.NODE_ENV === "development"
) {
  const microAppsList =
    (jenkinsConfig.microApps && jenkinsConfig.microApps?.split(",")) || [];
  config = getStagingVersionedUrl(config, microAppsList, jenkinsConfig.version);
}

if (
  process.env.NODE_ENV !== "staging" &&
  process.env.NODE_ENV !== "development"
) {
  config = attachAsyncAppsFromManifest(config, process.env.NODE_ENV);
}

export default config;
